<template>    
    <v-container fluid>         
        <v-row class="mb-6 course-dashboard-list">
            <v-col v-for="(category,index) in categories" :key="index" cols="12" sm="6" md="4" lg="3" xl="2" class="course-dashboard-list__item">
                <v-card>                                                    
<!--             <v-card raised v-for="(category,index) in categories" :key="index" class="mb-6 mx-auto">                    
              <router-link :to="{name: 'areas', params: { id: category.category_id }}"> 
 -->              <v-card-title style="color:#fff;cursor:pointer" @click="showCategory(category)" :style="getCategoryStyle(category)" class="layout justify-center course-dashboard-list__course-title"><span>{{category.title}}</span></v-card-title>
                    <v-card-text @click="showCategory(category)" style="cursor:pointer;" > <!-- class="layout justify-center" -->
                        <br>    
                        <v-card class="border-none category-details-card">
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs3> <v-layout><b> {{category.areas.text}}</b></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><b> {{category.courses.text}}</b></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><b> {{category.lessons.text}}</b></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><b> {{category.codes.text}}</b></v-layout></v-flex>
                                </v-layout>
                                <br>
                                <v-layout row wrap>
                                    <v-flex xs3> <v-layout><span>{{category.areas.value}}</span></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><span>{{category.courses.value}}</span></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><span>{{category.lessons.value}}</span></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><span>{{category.codes.value}}</span></v-layout></v-flex>
                                </v-layout>
                                </v-card-text>
                        </v-card>
                    </v-card-text>
                    
<!--                                     <v-simple-table width="100%" class="category-table background-transparent">
                                        <thead>
                                        <tr>
                                            <th class="text-center" width="25%">{{category.areas.text}}</th>
                                            <th class="text-center" width="25%">{{category.courses.text}}</th>
                                            <th class="text-center" width="25%">{{category.lessons.text}}</th>
                                            <th class="text-center" width="25%">{{category.codes.text}}</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr>
                                            <td class="text-center">{{category.areas.value}}</td>
                                            <td class="text-center">{{category.courses.value}}</td>
                                            <td class="text-center">{{category.lessons.value}}</td>
                                            <td class="text-center">{{category.codes.value}}</td>
                                        </tr>        
                                        </tbody>
                                    </v-simple-table>       -->                                
                           <!--  </router-link> -->
                            <v-card-actions >
                                <div v-if="$store.getters.isAdmin">
                                    <v-icon @click="editCategory(category.category_id)">mdi-pencil</v-icon>
                                    <v-icon @click="deleteCategory(category.category_id)" >mdi-delete</v-icon>
                                    <v-icon v-if="index > 0" @click="moveCategory(index, index-1)">mdi-arrow-left</v-icon>
                                    <v-icon v-if="index < categories.length-1"  @click="moveCategory(index, index+1)" >mdi-arrow-right</v-icon>                                    
                                </div>
                            </v-card-actions>
                </v-card>
            </v-col>
                <v-card raised v-if="$store.getters.isAdmin" class="mb-6 mx-auto">
                    <v-card-text>
                        <v-layout justify-center>
                            <v-icon size="x-large" @click="addCategory()">mdi-plus-circle-outline</v-icon> 
                        </v-layout>
                    </v-card-text>  
                </v-card>
        </v-row>
    </v-container>    
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            categories : []
        }
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            this.$store.commit('setBreadCrumbs',[])
            this.$store.commit('setFeedback', null)    
            // get category list
            axios.get('/get-categories2', this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                this.categories = res.data.list 

            })
            .catch(error => {
            this.$store.commit('setFeedback', error)          
            })            
        },
        addCategory() {
            this.$router.push({name:'admin_category', params: {id: '0'}})        
        },
        editCategory(id) {
            this.$router.push({name:'admin_category', params: {id: id}})        
        },
        deleteCategory(id) {
            this.$store.commit('setFeedback', null)    
            // get category list
            axios.get('/delete-category/' + id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        moveCategory(p1, p2) {
            const data = {
                category_id1: this.categories[p1].category_id,
                category_order1: this.categories[p1].sort_order,
                category_id2: this.categories[p2].category_id,
                category_order2: this.categories[p2].sort_order
            }

            axios.post('/category-change-order', data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var
                this.initData()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
      },
      showCategory(category) {
          this.$router.push({name:'areas', params: {id: category.category_id}})          
      },
      getCategoryStyle(category) {
          return 'background-color:'+category.color+';cursor:pointer';
      }
      
    }
}
</script>

<style>
/*.v-card__title {
    cursor: pointer;
    background-color: #00B1B0;
    color: #fff;
}
*/

.icon-edit {
  position: absolute;
  bottom: 4px;
  right: 100px;
  cursor: pointer;
}

.icon-delete {
  position: absolute;
  bottom: 4px;
  right: 68px;
  cursor: pointer;
}

.icon-up {
  position: absolute;
  bottom: 4px;
  right: 36px;
  cursor: pointer;
}

.icon-down {
  position: absolute;
  bottom: 4px;
  right: 4px;
  cursor: pointer;
}

</style>